import { call, put, select, takeLatest } from "redux-saga/effects";

import { getMoneys } from "services/money.service";

import { setData, setLoading } from "./dashboard.action";
import { Types } from "./dashboard.constant";
import { paramsSelector } from "./dashboard.selector";

import { pushErrorMessage } from "../snackbar/snackbar.action";

function* watchLoadData() {
  try {
    yield put(setLoading(true));

    // @ts-ignore
    const params = yield select(paramsSelector);

    const { count, data, total } = yield call(getMoneys, params);

    yield put(setData(count, data, total));
  } catch (e) {
    yield put(pushErrorMessage(e));
    yield put(setData(0, [], {}));
  }
}

export default function* root() {
  yield takeLatest(Types.LOAD_DATA, watchLoadData);
}
